module.exports = __webpack_public_path__ + "static/media/QRStore.9b82f6ae.svg";